import { config } from '@/config.ts';

type BrandBaseCurrencyConfig = Record<string, string>;

export const brandBaseCurrencyMap: BrandBaseCurrencyConfig = {
	default: 'KZT',
	nomad: 'KZT',
	ngu3: 'UAH',
	com2: 'UAH',
	blitz: 'TRY',
	rockets: 'UAH',
	rockets_vip: 'UAH',
	sk2: 'UAH',
	'1king': 'TRY'
};

export const getBrandBaseCurrency = (): string => {
	const brand = config.BRAND || 'default';
	return brandBaseCurrencyMap[brand] || brandBaseCurrencyMap.default;
};
